import type { APIProjectResponse } from "@/data_source/models/APIProjectResponse";
import type { WorkspaceContextState } from "@/data_source/models/APIWorkspaceContext";

export type WorkspaceContextRequirement = "operational" | "resolved" | "none";

export function shouldClearServiceForWorkspaceChange(
  requirement: WorkspaceContextRequirement
): boolean {
  return requirement !== "none";
}

export function getWorkspaceContextDependencyKey(options: {
  requirement: WorkspaceContextRequirement;
  ready: boolean;
  workspace?: Partial<APIProjectResponse> | null;
  context?: WorkspaceContextState | null;
}): string {
  if (options.requirement === "none") return "none";

  return [
    options.requirement,
    options.ready,
    options.workspace?.id ?? "no-workspace",
    options.workspace?.is_master === true,
    options.context?.resolvedWorkspace?.id ?? "no-context-workspace",
    options.context?.resolvedContextType ?? "no-context",
    options.context?.canOperate === true
  ].join(":");
}

export function canLoadForWorkspaceContext(options: {
  requirement: WorkspaceContextRequirement;
  ready: boolean;
  workspace?: Partial<APIProjectResponse> | null;
  context?: WorkspaceContextState | null;
}): boolean {
  if (options.requirement === "none") return true;
  if (!options.ready || !options.workspace?.id || !options.context)
    return false;
  if (options.context.resolvedWorkspace?.id !== options.workspace.id)
    return false;

  if (options.requirement === "resolved") return true;

  return (
    options.context.resolvedContextType === "operational" &&
    options.context.canOperate === true &&
    options.workspace.is_master !== true
  );
}
